/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InvoiceChallengeMergeField } from "./InvoiceChallengeMergeField";
import {
  InvoiceChallengeMergeFieldFromJSON,
  InvoiceChallengeMergeFieldFromJSONTyped,
  InvoiceChallengeMergeFieldToJSON,
  InvoiceChallengeMergeFieldToJSONTyped,
} from "./InvoiceChallengeMergeField";

/**
 *
 * @export
 * @interface InvoiceChallengeTemplate
 */
export interface InvoiceChallengeTemplate {
  /**
   *
   * @type {string}
   * @memberof InvoiceChallengeTemplate
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceChallengeTemplate
   */
  bodyMarkdown: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceChallengeTemplate
   */
  introMarkdown?: string | null;
  /**
   *
   * @type {Array<InvoiceChallengeMergeField>}
   * @memberof InvoiceChallengeTemplate
   */
  mergeFields: Array<InvoiceChallengeMergeField>;
  /**
   *
   * @type {Array<InvoiceChallengeMergeField>}
   * @memberof InvoiceChallengeTemplate
   */
  introMergeFields: Array<InvoiceChallengeMergeField>;
}

/**
 * Check if a given object implements the InvoiceChallengeTemplate interface.
 */
export function instanceOfInvoiceChallengeTemplate(
  value: object,
): value is InvoiceChallengeTemplate {
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("bodyMarkdown" in value) || value["bodyMarkdown"] === undefined)
    return false;
  if (!("mergeFields" in value) || value["mergeFields"] === undefined)
    return false;
  if (!("introMergeFields" in value) || value["introMergeFields"] === undefined)
    return false;
  return true;
}

export function InvoiceChallengeTemplateFromJSON(
  json: any,
): InvoiceChallengeTemplate {
  return InvoiceChallengeTemplateFromJSONTyped(json, false);
}

export function InvoiceChallengeTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeTemplate {
  if (json == null) {
    return json;
  }
  return {
    subject: json["subject"],
    bodyMarkdown: json["bodyMarkdown"],
    introMarkdown:
      json["introMarkdown"] == null ? undefined : json["introMarkdown"],
    mergeFields: (json["mergeFields"] as Array<any>).map(
      InvoiceChallengeMergeFieldFromJSON,
    ),
    introMergeFields: (json["introMergeFields"] as Array<any>).map(
      InvoiceChallengeMergeFieldFromJSON,
    ),
  };
}

export function InvoiceChallengeTemplateToJSON(
  json: any,
): InvoiceChallengeTemplate {
  return InvoiceChallengeTemplateToJSONTyped(json, false);
}

export function InvoiceChallengeTemplateToJSONTyped(
  value?: InvoiceChallengeTemplate | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subject: value["subject"],
    bodyMarkdown: value["bodyMarkdown"],
    introMarkdown: value["introMarkdown"],
    mergeFields: (value["mergeFields"] as Array<any>).map(
      InvoiceChallengeMergeFieldToJSON,
    ),
    introMergeFields: (value["introMergeFields"] as Array<any>).map(
      InvoiceChallengeMergeFieldToJSON,
    ),
  };
}
